import { z } from "zod";
import { fileSchema } from "@/api/http/schemas/fileSchemas";

export const funderSchema = z.object({
  id: z.string(),
  full_name: z.string(),
  description: z.string().nullable(),
  logo: fileSchema.nullable(),
  website: z.string().nullable(),
});

export type Funder = z.infer<typeof funderSchema>;
